import React, { useRef, useState, useEffect } from 'react';
import './Home.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';


interface HomeProps {
  navbarRef: React.RefObject<HTMLDivElement | null>;
  footerRef: React.RefObject<HTMLDivElement | null>;
}

const Home: React.FC<HomeProps> = ({ navbarRef, footerRef }) => {
  const [homePageHeight, setHomePageHeight] = useState<string>('100vh');

  const navigate = useNavigate();
  const handleDownloadClick = () => {
    navigate('/download');
  }

  const calculateHeight = () => {
    console.log(navbarRef, footerRef)
    if (navbarRef.current && footerRef.current) {
      const navbarHeight = navbarRef.current.offsetHeight;
      const footerHeight = footerRef.current.offsetHeight;
      const windowHeight = window.innerHeight;

      const height = `${windowHeight - (navbarHeight + footerHeight)-50}px`;
      console.log(windowHeight, height, navbarHeight, footerHeight)
      setHomePageHeight(height);
    }
  }

  useEffect(() => {
    calculateHeight();
    window.addEventListener('resize', calculateHeight);

    // Cleanup the event listener on unmount
    return () => {
      window.removeEventListener('resize', calculateHeight);
    };
  }, []);

  return (
    <div className="home-page" style={{ height: homePageHeight }}>
      <div className="hero-section">
        <div className="overlay-text">
          <h1>Overcoming Temptation</h1>
          <hr />
          <h2>Biblical Principles for Daily Victory</h2>
          <div className="download-section" onClick={handleDownloadClick}>
            <div className="download-link">
              <FontAwesomeIcon icon={faDownload} />
              <hr />
              <div className="download-text">Download</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
